import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TipoAsesorReal } from 'src/app/domain/model/catalogo/tipo-asesor-real';

/**
 * Adaptador HTTP: HttpTipoAsesorRealRepository
 *
 * Servicio para comunicación HTTP con backend de Tipos de Asesor Real.
 * Endpoints: /api/servicios/tipos-asesor-real/*
 *
 * @author Emerson Rodriguez - Ingeneo
 */
@Injectable({ providedIn: 'root' })
export class HttpTipoAsesorRealRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/tipos-asesor-real`;

  /**
   * Lista todos los tipos de asesor activos
   * Usado en: Programación Masiva - Checkboxes de tipo asesor
   */
  async listarActivos(): Promise<TipoAsesorReal[]> {
    return firstValueFrom(
      this.http.get<TipoAsesorReal[]>(this.baseUrl)
    );
  }

  /**
   * Obtiene un tipo de asesor por código
   */
  async obtenerPorCodigo(codigo: string): Promise<TipoAsesorReal> {
    return firstValueFrom(
      this.http.get<TipoAsesorReal>(`${this.baseUrl}/${codigo}`)
    );
  }
}
